/* tslint:disable:max-line-length */

export const getDeveloperInstructions = (promoterJSCode: string) => `Hello,
In order to successfully capture details from your anonymous website visitors your javascript must be placed on your website.
Your instructions for installing Customers.ai X-ray website visitor detector are below.
Paste the code below immediately after the <head> tag of index.html file.
You can use the settings in Customers.ai to restrict capture on certain pages, users, or actions.

Instructions for installing the script can be found at https://customers.ai/help/l/en/article/16hdqqv4tu-x-ray-installation-guide.

${promoterJSCode}

Please note: Shopify users need to install a second additional script in the customer events area of Shopify,
that script can be found on your Customers.ai Dashboard.`;

export const advancedScript = `<script>
window.xrayDataLayer = window.xrayDataLayer || [];
function xrayData() { xrayDataLayer.push(arguments); }
</script>`;

export const getDeveloperInstructionsAdvanced = (
  promoterJSCode: string,
) => `${getDeveloperInstructions(promoterJSCode)}.

Add the following code below the existing <script> tag that includes the X-Ray Website Script:

${advancedScript}

How to customize the customer journey's code
In an event handler (e.g., the click event on a button), 
you can trigger a customer journey events by making a call to the xrayData method with the page_view event type together with the desired URL.

Examples:

document.querySelector('button.add-to-cart').addEventListener('click', function () { xrayData('page_view', 'https://example.org/use-a-unique-url-here') });

In this example, we are adding the trigger to an HTML button with the add-to-cart CSS class. 
(e.g., <button class=”add-to-cart”>Add to Cart</button>)

<button onclick="xrayData('page_view', 'https://example.org/use-a-unique-url-here')”>Add to Cart</button>

In this example, we are customizing the HTML button to add an onclick handler, 
which triggers a customer journey even when the user clicks on the button.

How to customize the contacts attributes
To set an attribute, use the set_attribute method of the Xray API, 
where the two parameters can be any desired attribute name and value, such as:

xrayData('set_attribute', 'attribute_name', 'attribute_value')

Payload Example:

Headers:
{ "token": "12312lk3j1lk2j3kl1j2lk31kl2j3kj", "other_header": "value", "Authorization": "Basic am9obkBleGFtcGxlLmNvbTphYmMxMjM=" }

Bodies:
{ "squadName": "Super hero squad", "homeTown": "Metro City", "formed": 2016, "secretBase": "Super tower", "active": true }
`;
